import store from "../store";
import { AxiosRequestConfig } from "axios";

/**
 * シンクライアントで操作したときのシステムログ対策
 * HttpRepositoryかHttpClientに処理を注入できたらよさそう
 */
export class ConfiguredRequestConfig {
  static create(config?: AxiosRequestConfig): AxiosRequestConfig {
    const clientIpAddress = store.getters.clientIpAddress;
    const token = store.getters.token;
    // 付け加える情報が無い場合はそのまま返却する
    if (!clientIpAddress && !token) { return config; }
    
    const configured: AxiosRequestConfig = !!config ? config : {};
    if (!configured.headers) {
      configured.headers = {};
    }
    if (clientIpAddress) {
      const clientIpAddressHeader = {
        "x-client-ip-address": clientIpAddress,
      };
      // spread構文でマージしている
      configured.headers = {...configured.headers, ...clientIpAddressHeader};
    }
    if (token) {
      configured.headers.Authorization = "Bearer " + token;
    }
    return configured;
  }
}
